import { lazy } from 'react';

/** Открывает экран планировщика */
export const CronJobDetailsPageAsync = lazy(() => import('./CronJobDetailsPage'));
